import * as types from './types';

const initialState = {
  getYouthAdvisoryCouncil: {},
  postYouthAdvisoryCouncil: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_YOUTH_ADVISORY_COUNCIL_SUCCESS: {
      return {
        ...state,
        getYouthAdvisoryCouncil: action.payload
      };
    }
    case types.GET_YOUTH_ADVISORY_COUNCIL_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_YOUTH_ADVISORY_COUNCIL_SUCCESS: {
      return {
        ...state,
        postYouthAdvisoryCouncil: action.payload
      };
    }
    case types.POST_YOUTH_ADVISORY_COUNCIL_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
